<template>
  <div
    class="filter-icon-container"
    @mouseover="() => (showText = true)"
    @mouseleave="() => (showText = false)"
  >
    <FilterIcon stroke="#007f80" />
    <span v-if="showText" class="filter-icon-text">{{ iconText }}</span>
  </div>
</template>

<script>
import FilterIcon from "@/components/svg-icons/FilterIcon.vue";

export default {
  name: "IconWithText",
  components: {
    FilterIcon,
  },
  props: {
    iconText: {
      type: String,
      default: "Filters",
    },
  },
  data() {
    return {
      showText: false,
    };
  },
};
</script>

<style scoped>
.filter-icon-container {
  display: inline-flex;
  align-items: center;
  position: relative;
  width: auto;
  height: 32px;
  background: #FFFFFF;
  border: 1px solid #007F80;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.15);
  border-radius: 100px;
  padding: 10px;
  transition: background-color 0.3s ease;
}

.filter-icon {
  object-fit: contain;
}

.filter-icon-container:hover {
  background-color: #f0f0f0;
}

.filter-icon-text {
  margin-left: 7px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #007f80;
  transition: opacity 0.3s ease;
}
</style>
